/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateFacilityCustomTagRequest
 */
export interface UpdateFacilityCustomTagRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateFacilityCustomTagRequest
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateFacilityCustomTagRequest
     */
    facility_ids: Array<string>;
}

/**
 * Check if a given object implements the UpdateFacilityCustomTagRequest interface.
 */
export function instanceOfUpdateFacilityCustomTagRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "facility_ids" in value;

    return isInstance;
}

export function UpdateFacilityCustomTagRequestFromJSON(json: any): UpdateFacilityCustomTagRequest {
    return UpdateFacilityCustomTagRequestFromJSONTyped(json, false);
}

export function UpdateFacilityCustomTagRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFacilityCustomTagRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'facility_ids': json['facility_ids'],
    };
}

export function UpdateFacilityCustomTagRequestToJSON(value?: UpdateFacilityCustomTagRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'facility_ids': value.facility_ids,
    };
}

